import { convertFromRaw, convertToRaw, EditorState, genKey, SelectionState } from 'draft-js';

import { hasContent, insertContentState } from 'my-core/editor-utils';

const STORAGE_KEY = 'editor-selection';

class CopyManager {
  _listeners = [];

  // constructor() {
  // }

  addChangeListener = callback => {
    this._listeners.push(callback);
  };
  removeChangeListener = callback => {
    this._listeners = this._listeners.filter(cb => cb !== callback);
  };

  hasClipboardData() {
    return !!window.localStorage.getItem(STORAGE_KEY);
  }

  addSelectionToClipboard(editorState) {
    const selection = editorState.getSelection();
    const content = editorState.getCurrentContent();
    const rawContent = convertToRaw(content);

    const selectedBlocks = rawContent.blocks.slice(
      rawContent.blocks.findIndex(b => b.key === selection.getStartKey()),
      rawContent.blocks.findIndex(b => b.key === selection.getEndKey()) + 1,
    );
    const selectedRawContent = {
      blocks: selectedBlocks,
      entityMap: selectedBlocks.reduce((result, block) => {
        block.entityRanges.forEach(er => (result[er.key] = rawContent.entityMap[er.key]));
        return result;
      }, {}),
    };
    this.addContentToClipboard(selectedRawContent);
  }

  addContentToClipboard(content) {
    if (!this.hasClipboardData() && hasContent(content)) {
      this._listeners.forEach(cb => cb(true));
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(content));
  }

  insertClipboardData(editorState) {
    const copiedContent = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (!copiedContent) return editorState;
    const lastBlock = copiedContent.blocks[copiedContent.blocks.length - 1];
    const focusKey = (lastBlock.key = genKey());
    const focusOffset = lastBlock.text.length;

    const selection = editorState.getSelection();
    const key = selection.getStartKey();
    const contentState = editorState.getCurrentContent();
    const insertKey = selection.getStartOffset() ? contentState.getKeyAfter(key) : key;
    const origContent = convertToRaw(contentState);

    const newRawContent = insertContentState(origContent, copiedContent, insertKey);
    const newContentState = convertFromRaw(newRawContent);

    const newEditorState = EditorState.push(editorState, newContentState, 'insert-fragment');

    return EditorState.forceSelection(
      newEditorState,
      new SelectionState({
        anchorKey: focusKey,
        anchorOffset: focusOffset,
        focusKey: focusKey,
        focusOffset: focusOffset,
      }),
    );
  }
}

export default new CopyManager();
